import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-279f8f91"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "group-box" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "group-list"
}
const _hoisted_5 = { class: "group-list-item" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "group-list-item" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-right" }, null, -1))
const _hoisted_10 = { class: "group-list-item" }
const _hoisted_11 = { class: "content" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-right" }, null, -1))
const _hoisted_13 = { class: "group-list-introduction" }
const _hoisted_14 = { class: "group-list-item" }
const _hoisted_15 = {
  key: 0,
  class: "select"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "select-item-header" }
const _hoisted_18 = { class: "left" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "select-item-label" }
const _hoisted_21 = {
  key: 0,
  class: "icon icon-selected"
}
const _hoisted_22 = { class: "select-item-detail" }
const _hoisted_23 = ["href"]
const _hoisted_24 = { class: "content" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-right" }, null, -1))
const _hoisted_26 = {
  key: 0,
  class: "group-h5-list-item-introduction"
}
const _hoisted_27 = { class: "introduction-name" }
const _hoisted_28 = { class: "introduction-detail" }
const _hoisted_29 = ["href"]
const _hoisted_30 = {
  key: 1,
  class: "group-list group-list-edit"
}
const _hoisted_31 = ["placeholder"]
const _hoisted_32 = {
  key: 1,
  class: "select"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "select-item-header" }
const _hoisted_35 = { class: "left" }
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "select-item-label" }
const _hoisted_38 = {
  key: 0,
  class: "icon icon-selected"
}
const _hoisted_39 = { class: "select-item-detail" }
const _hoisted_40 = ["href"]
const _hoisted_41 = { class: "group-profile-footer" }
const _hoisted_42 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["group", [_ctx.isH5 ? 'group-h5' : '']])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("header", null, [
        (!_ctx.isEdit)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_ctx.$t('TUISearch.发起群聊')), 1))
          : (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(_ctx.$t(`TUISearch.${_ctx.editConfig.title}`)), 1)),
        _createElementVNode("i", {
          class: _normalizeClass(["icon", [_ctx.isH5 ? 'icon-back' : 'icon-close']]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
        }, null, 2)
      ]),
      (!_ctx.isEdit)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
            _createElementVNode("li", _hoisted_5, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('TUISearch.群头像')), 1),
              _createElementVNode("img", {
                class: "icon",
                src: _ctx.profile.avatar
              }, null, 8, _hoisted_6)
            ]),
            _createElementVNode("ul", null, [
              _createElementVNode("li", _hoisted_7, [
                _createElementVNode("label", null, _toDisplayString(_ctx.$t('TUISearch.群名称')), 1),
                (!_ctx.isH5)
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 0,
                      type: "text",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.profile.name) = $event)),
                      placeholder: "请输入群名称"
                    }, null, 512)), [
                      [_vModelText, _ctx.profile.name]
                    ])
                  : (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: "group-h5-list-item-content",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.edit('name')))
                    }, [
                      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.profile.name), 1),
                      _hoisted_9
                    ]))
              ]),
              _createElementVNode("li", _hoisted_10, [
                _createElementVNode("label", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('TUISearch.群ID')), 1),
                  _createElementVNode("text", null, "(" + _toDisplayString(_ctx.$t('TUISearch.选填')) + ")", 1)
                ]),
                (!_ctx.isH5)
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 0,
                      type: "text",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.profile.groupID) = $event))
                    }, null, 512)), [
                      [_vModelText, _ctx.profile.groupID]
                    ])
                  : (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: "group-h5-list-item-content",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.edit('groupID')))
                    }, [
                      _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.profile.groupID), 1),
                      _hoisted_12
                    ]))
              ]),
              _createElementVNode("li", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("label", null, _toDisplayString(_ctx.$t('TUISearch.群类型')), 1),
                  (!_ctx.isH5)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_15, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.type, (item, index) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: _normalizeClass(["select-item", [_ctx.profile.type === item.type && 'selected']]),
                            key: index,
                            onClick: ($event: any) => (_ctx.selected(item))
                          }, [
                            _createElementVNode("main", null, [
                              _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("aside", _hoisted_18, [
                                  _createElementVNode("img", {
                                    class: "icon",
                                    src: item.icon
                                  }, null, 8, _hoisted_19),
                                  _createElementVNode("span", _hoisted_20, _toDisplayString(item.label), 1)
                                ]),
                                (_ctx.profile.type === item.type)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_21))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t(`TUISearch.${item.detail}`)), 1),
                              _createElementVNode("a", {
                                href: _ctx.Link.product.url,
                                target: "view_window"
                              }, _toDisplayString(_ctx.$t(`TUISearch.${item.src}`)), 9, _hoisted_23)
                            ])
                          ], 10, _hoisted_16))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: "group-h5-list-item-content",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.edit('type')))
                      }, [
                        _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.groupTypeDetail.label), 1),
                        _hoisted_25
                      ]))
                ]),
                (_ctx.isH5)
                  ? (_openBlock(), _createElementBlock("article", _hoisted_26, [
                      _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.groupTypeDetail.label) + "：", 1),
                      _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t(`TUISearch.${_ctx.groupTypeDetail.detail}`)), 1),
                      _createElementVNode("a", {
                        href: _ctx.Link.product.url,
                        target: "view_window"
                      }, _toDisplayString(_ctx.$t(`TUISearch.${_ctx.groupTypeDetail.src}`)), 9, _hoisted_29)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_30, [
            (_ctx.editConfig.type === 'input')
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  type: "text",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editConfig.value) = $event)),
                  placeholder: _ctx.$t(`TUISearch.${_ctx.editConfig.placeholder}`)
                }, null, 8, _hoisted_31)), [
                  [_vModelText, _ctx.editConfig.value]
                ])
              : (_openBlock(), _createElementBlock("ul", _hoisted_32, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.type, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: _normalizeClass(["select-item", [_ctx.editConfig.value === item.type && 'selected']]),
                      key: index,
                      onClick: ($event: any) => (_ctx.selectedEdit(item))
                    }, [
                      _createElementVNode("main", null, [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("aside", _hoisted_35, [
                            _createElementVNode("img", {
                              class: "icon",
                              src: item.icon
                            }, null, 8, _hoisted_36),
                            _createElementVNode("span", _hoisted_37, _toDisplayString(item.label), 1)
                          ]),
                          (_ctx.editConfig.value === item.type)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_38))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t(`TUISearch.${item.detail}`)), 1),
                        _createElementVNode("a", {
                          href: _ctx.Link.product.url,
                          target: "view_window"
                        }, _toDisplayString(_ctx.$t(`TUISearch.${item.src}`)), 9, _hoisted_40)
                      ])
                    ], 10, _hoisted_33))
                  }), 128))
                ]))
          ])),
      _createElementVNode("footer", _hoisted_41, [
        (!_ctx.isEdit && !_ctx.isH5)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn-default",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
            }, _toDisplayString(_ctx.$t('TUISearch.取消')), 1))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "btn-submit",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.submit(_ctx.profile))),
          disabled: _ctx.profile.name === '' && !_ctx.isEdit
        }, _toDisplayString(_ctx.$t('TUISearch.创建')), 9, _hoisted_42)
      ])
    ])
  ], 2))
}